import React from 'react';

import { Box, Flex, Progress, Space, Text } from '@mantine/core';
import { UsageProgress } from 'shared/interfaces/Usage';

interface UsageTableProps {
  progressItems: UsageProgress[];
}

export function UsageTable({ progressItems }: UsageTableProps) {
  return (
    <>
      {progressItems.map((usageProgress: UsageProgress, key: number) => {
        return (
          <Box key={key} p={8}>
            <Flex direction="row" justify="space-between" align="center">
              <Flex align="center">
                {usageProgress.icon}
                <Space w={10} />
                <Text>{usageProgress.label}</Text>
              </Flex>
              <Text>{usageProgress.progressLabel}</Text>
            </Flex>
            <Space h={5} />
            <Progress
              radius="lg"
              value={usageProgress.value > 0 ? (usageProgress.value / usageProgress.max) * 100 : 0}
            />
          </Box>
        );
      })}
    </>
  );
}
